// extracted by mini-css-extract-plugin
module.exports = {"fancyRule":"FancyRule-module--fancy-rule--1DiUb"};